<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path fill="none" d="M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4" :stroke="fill"></path> <path fill="none" d="M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5" :stroke="fill"></path> <path fill="none" d="M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5" :stroke="fill"></path> <path fill="none" d="M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6" :stroke="fill"></path> <polyline fill="none" points="27.081,31 3,31 3,11 45,11 45,31 40,31 " :stroke="fill"></polyline> <circle fill="none" cx="23" cy="21" r="4"></circle> <line fill="none" x1="13" y1="17" x2="9" y2="17"></line> <path fill="none" d="M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8" :stroke="fill"></path></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>